import * as yup from "yup";


export const uploadAndCreateCustomPDValidation = () => {
  const schema = yup.object().shape({
    customPDTitle: yup.string().label('This field').required().max(200),
    customPDFile: yup
      .mixed()
      .test(
        "fileReqValidation",
        "This field is required",
        (file) => {
          // console.log("gl-validate:", file)
          return (!!file[0]);
        }
      )
      .test(
        "fileTypeValidation",
        "Only doc/excel/pdf/ppt file type is allowed",
        (file) => {
          /**mime list for ppt/pdf */
          const fileMIMETypeList = [
            /**pdf */
            "application/pdf",
            /**ppt */
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",

            /**excel */
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

            /**word */
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ];
          //if u want to allow only certain file types only

          return (
            !file[0] || (!!file[0] && fileMIMETypeList.includes(file[0].type))
          );
        }
      )
      .test(
        "fileSizeValidation",
        "The file size should be less than 20MB",
        (file) => {
          // console.log("gl-validate:", file)
          //if u want to allow only certain file sizes
          return !file[0] || (!!file[0] && file[0].size <= 20 * 1024 * 1024);
        }
      ),
  });

  return { schema };
};
